import { Store } from "vuex";
import createApis from "./apis";

export default createApis;

export interface ApiUseOptions {
  configs: {
    FUSION_API_HOST: string;
  };
  store: Store<any>;
}
